let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8w7dN")).then(() => parcelRequire('aidKx'));